/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImageModels } from '../../models/image-models';

export interface ImageDetail$Params {
  patientId: string | null;
  emrpracticeId?: string | null;
  Id?: string | null;
  DocumentType?: string | null;
  InDataBase?: string | null;
  UserId?: string | null;
  FileType?: string | null;
}

export function imageDetail(http: HttpClient, rootUrl: string, params: ImageDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageModels>> {
  const rb = new RequestBuilder(rootUrl, imageDetail.PATH, 'get');
  if (params) {
    rb.path('patientId', params.patientId, {});
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('Id', params.Id, {});
    rb.query('DocumentType', params.DocumentType, {});
    rb.query('InDataBase', params.InDataBase, {});
    rb.query('UserId', params.UserId, {});
    rb.query('FileType', params.FileType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImageModels>;
    })
  );
}

imageDetail.PATH = '/image/getdetails/{patientId}';
